export default "__VITE_ASSET__Ba88ZSZY__"